export default __webpack_public_path__ + "static/media/me@x1.0930c789.jpg";